import React, {useContext, useEffect, useState} from 'react';
import OrderProductionTable from "../../../../components/UI/table/orders/organization/production/OrderProductionTable";
import OrderService from "../../../../API/orders/orders/organization/OrderService";
import OrderUtil from "../../../../utils/orders/OrderUtil";
import {useLocation, useParams} from "react-router-dom";
import TypeJobService from "../../../../API/orders/orders/organization/TypeJobService";
import {EditLocalStoragePagesData} from "../../../../utils/EditLocalStoragePagesData";
import ModalAlert from "../../../../components/UI/table/customer-detales/ModalAlert";
import {constantsErrorMessages} from "../../../../Constants";
import {Box} from "@mui/system";
import {BreadcrumbsComponent} from "../../../../components/UI/breadcrumb/BreadcrumbComponent";
import Typography from "@mui/material/Typography";
import {calcFilterData} from "../../../../utils/common/calcFilterData";
import {OrderProductionTableFiltererData} from "../../../../data/FilterTables/OrderProductionTableFiltererData";
import DataUtil from "../../../../utils/common/DataUtil";
import CircularProgress from "@mui/material/CircularProgress";

const PlanItem = () => {
    const pathname = useLocation().pathname
    const [data, setData] = useState([]);
    const [customerList, setCustomerList] = useState([]);
    const [nameList, setNameList] = useState([]);
    const [attributeList, setAttributeList] = useState([]);
    const [planningList, setPlanningList] = useState([]);
    const [additionallyColumn, setAdditionallyColumn] = useState([]);
    const [alertData, setAlertData] = useState({});
    const [filteredData, setFilteredData] = useState(data)
    const [globalFilter, setGlobalFilter] = useState('');
    const [columnsFilter, setColumnsFilter] = useState([]);
    const [isLoading, setIsLoading] = useState(true)
    const [tableOptions, setTableOptions] = useState({
        pageIndex: 0,
        pageSize: 100,
        totalElements: 0,
        searchData: ""
    })
    const tableOptionsHandle = (nextState) => {
        setTableOptions(nextState)
        if (nextState.pageSize !== tableOptions.pageSize) {
            EditLocalStoragePagesData(pathname, "pageSize", nextState.pageSize)
        }
    }
    const handleModalAlert = (message, type = "error") => {
        setAlertData({
            type: type,
            open: true,
            message: type === "success" ? message : message.response?.data?.message || constantsErrorMessages[message.response?.status] || message.message
        })
    }
    const handleSearchQuery = (searchQuery, prevData, pageSize, isColumnFilters) => {
        const newColumnsFilter = isColumnFilters ? searchQuery : columnsFilter
        const newGlobalFilter = isColumnFilters ? globalFilter : searchQuery || ""

        const data = [...prevData]
        const globalFilterData = newGlobalFilter ? calcFilterData(data, newGlobalFilter, OrderProductionTableFiltererData) : data
        const newData = newColumnsFilter.reduce((accumulator, currentValue) => {
            return calcFilterData(accumulator, currentValue?.value, [OrderProductionTableFiltererData.find(el => el.idFromColumnFilter === currentValue.id)])
        }, globalFilterData);

        setFilteredData(newData)

        tableOptionsHandle({
            ...tableOptions,
            totalElements: newData.length,
            pageSize: pageSize ? pageSize : tableOptions?.pageSize
        })

        if (isColumnFilters) {
            setColumnsFilter(searchQuery)
        } else {
            setGlobalFilter(searchQuery || "")
            if (searchQuery !== globalFilter) {
                EditLocalStoragePagesData(pathname, "searchQuery", searchQuery)
            }
        }
    }

    const getStartPageSize = () => {
        const pagesData = JSON.parse(localStorage.getItem('pagesData')) || {}
        const pageSize = pagesData[pathname]?.pageSize
        const searchQuery = pagesData[pathname]?.searchQuery

        return {searchQuery, pageSize}
    }
    const params = useParams();

    let {id, name} = params;

    const setLists = (data) => {
        setCustomerList(OrderUtil.getListField(data, 'customerName'));
        setNameList(OrderUtil.getListField(data, 'header'));
        setAttributeList(OrderUtil.getStatuses(data, 'attributes'));
        setPlanningList(OrderUtil.getListField(data, 'state'));
    }
    useEffect(() => {
        const {searchQuery, pageSize} = getStartPageSize()
        TypeJobService.getAllByOrganizationId().then(function (response) {
            const data = response.data
            data.sort((a, b) => b.outputPriority - a.outputPriority);
            setAdditionallyColumn(data);
        })
            .catch(function (error) {
                handleModalAlert(error);
            });

        OrderService.getOrdersProductionByPlanId(id).then(function (response) {
            const data = response.data;
            handleSearchQuery(searchQuery, data, pageSize)
            setData(data);
            setLists(data)
        })
            .catch(function (error) {
                handleModalAlert(error);
            }).finally(() => setIsLoading(false))
    }, []);

    return (
        <Box sx={{padding: "0 30px"}}>
            <BreadcrumbsComponent
                page={`План ${name}`}
                path={[{name: "Главная", href: "/"}, {name: "Планы", href: "/organization/plans"}]}/>
            <Typography sx={{fontSize: "24px", fontWeight: 700}}>
                План {name}
            </Typography>
            {isLoading ?
                <Box sx={{
                    height: `calc(100vh - 450px)`,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center"
                }}>
                    <CircularProgress disableShrink/>
                </Box> : <OrderProductionTable
                    data={data}
                    setData={setData}
                    customerList={customerList}
                    nameList={nameList}
                    attributeList={attributeList}
                    planningList={planningList}
                    isPlan={true}
                    additionallyColumn={additionallyColumn}
                    tableOptions={tableOptions}
                    tableOptionsHandle={tableOptionsHandle}
                    handleModalAlert={handleModalAlert}
                    globalFilter={globalFilter}
                    filteredData={filteredData}
                    handleSearchQuery={handleSearchQuery}
                    columnsFilter={columnsFilter}
                    setLists={setLists}
                />}
            <ModalAlert
                data={alertData}
                onClose={() => setAlertData((alert) => ({...alert, open: false}))}
            />
        </Box>
    );
};

export default PlanItem;